import openSocket from "socket.io-client";
import { getBackendUrl } from "../config";

let socketInstance = null;

function connectToSocket() {
  let token = localStorage.getItem("token");
  try {
    token = token ? JSON.parse(token) : null;
  } catch (e) {
    // Si ya es un token en texto plano o JWT, se usa tal cual
  }

  if (!socketInstance) {
    socketInstance = openSocket(getBackendUrl(), {
      transports: ["websocket", "polling"],
      query: {
        token: token || "",
      },
      autoConnect: !!token,
      reconnection: true,
      reconnectionDelay: 1000,
      reconnectionDelayMax: 5000,
      reconnectionAttempts: Infinity,
    });

    // Guard against component unmounts destroying the app-wide connection
    socketInstance.realDisconnect = socketInstance.disconnect.bind(socketInstance);
    socketInstance.disconnect = function () {
      // Intentionally empty: prevents individual components from killing the global connection
    };
  } else {
    if (token && socketInstance.io && socketInstance.io.opts) {
      socketInstance.io.opts.query = { token };
    }
    if (socketInstance.disconnected && token) {
      socketInstance.connect();
    }
  }

  return socketInstance;
}

export default connectToSocket;
